//valid auth actions
export const FETCH_CAS_TICKET = "FETCH_CAS_TICKET"
export const FETCH_JWT = "FETCH_JWT"
export const JWT_FETCH_SUCCESS = "JWT_FETCH_SUCCESS"
export const NOTIFY_AUTH_FAILURE = "NOTIFY_AUTH_FAILURE"
export const ON_SUCCESSFUL_AUTHORIZATION = "ON_SUCCESSFUL_AUTHORIZATION"
export const LOGOUT = "LOGOUT"



